export default "__VITE_ASSET__6541cd84__"